import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";

import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import AvatarComponent from "./avatar";
import TypoSession from "../../../partials/typoSession";
import TypoTitle from "../../../partials/typoTitle";
import SnackbarComponent from "../../snackbar";
import { styles } from "./styles";
import Loading from "../../loading";
import InputFileReader from "../../fileReader";
class ServiceOwner extends React.Component {
  constructor(props) {
    super(props);
  }
  handleSubmit = async (data = {}) => {
    const { t, disabled } = this.props;

    if (!disabled) {
      if (data && data.support && typeof data.support !== "string") {
        data.support = JSON.stringify(data.support);
      }
      this.loading.startLoading();
      let check = await this.props.updateServiceForOwner({ data: data });
      this.loading.stopLoading();
      if (check.code === 1) {
        this.mSnackbar.handleClick(
          t("service_ownerspa_servicedetail_update_successfully")
        );
      } else {
        this.mSnackbar.handleClick(
          t("service_ownerspa_servicedetail_update_unsuccessfully") +
            " " +
            check.message,
          "error"
        );
      }
    }
  };
  handleUpdate = async (file) => {
    const { t, service = {}, disabled, preview, fileUpload } = this.props;

    if (!disabled && !preview) {
      // preview: xem trước hình và gọi function upload bên ngoài (trong create service role admin)
      this.loading.startLoading();
      let checkUpload = await this.props.uploadDispatch.saveStorage({
        files: file,
        code: service.no,
        imgPre: service.imageUrl,
        type: "img-service",
      });
      this.loading.stopLoading();
      if (checkUpload.code === 1) {
        this.handleSubmit({
          ...service,
          imageUrl: checkUpload.data.previewLink,
        });
      } else {
        this.mSnackbar.handleClick(
          t("service_ownerspa_servicedetail_update_image_unsuccessfully") +
            " " +
            checkUpload.message,
          "error"
        );
      }
    } else if (preview && fileUpload) {
      fileUpload(file);
    }
  };
  handleDelete = () => {
    const { t, service = {}, disabled } = this.props;

    if (service.imageUrl && !disabled) {
      this.handleSubmit({
        ...service,
        imageUrl: "",
      });
    }
  };
  handleUpdateLogo = async (file, src) => {
    const { t, service = {}, disabled, preview, fileUploadLogo } = this.props;

    if (!disabled && !preview && file !== null) {
      // preview: xem trước hình và gọi function upload bên ngoài (trong create service role admin)
      this.loading.startLoading();
      let checkUpload = await this.props.uploadDispatch.saveStorage({
        files: file,
        code: service.no,
        imgPre: service.logo,
        type: "img-logo",
      });
      this.loading.stopLoading();
      if (checkUpload.code === 1) {
        this.handleSubmit({
          ...service,
          logo: checkUpload.data.previewLink,
        });
      } else {
        this.mSnackbar.handleClick(
          t("service_ownerspa_servicedetail_update_image_unsuccessfully") +
            " " +
            checkUpload.message,
          "error"
        );
      }
    } else if (!disabled && !preview && src !== null) {
      this.handleSubmit({
        ...service,
        logo: src,
      });
    } else if (preview && fileUploadLogo) {
      // lúc create service bên admin
      fileUploadLogo(file);
    }
  };
  handleDeleteLogo = () => {
    const { t, service = {}, disabled } = this.props;
    if (service.logo && !disabled) {
      this.handleSubmit({
        ...service,
        logo: "",
      });
    }
  };
  imageSelect = async (imageURL) => {
    const { service = {} } = this.props;
    this.handleSubmit({
      ...service,
      imageUrl: imageURL,
    });
  };
  render() {
    const {
      t,
      classes,
      service = {},
      disabled = false,
      dropMenu = "",
      handleUpdateLogo = null,
    } = this.props;
    return (
      <>
        <SnackbarComponent
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <div className={classes.headerImage}>
          <InputFileReader
            disabled={disabled}
            type="notPreview"
            onRef={(id) => (this.InputFileReader = id)}
            cover={true}
            width={false}
            update={this.handleUpdate}
            delete={this.handleDelete}
            selectStorageMode={!handleUpdateLogo ? true : false}
            imageSelect={this.imageSelect}
            defaultImg={service.imageUrl}
            container="square"
            styleBg={{
              backgroundColor: "#1c1e21",
              // backgroundImage: service.imageUrl || "none"
            }}
          />
          <div className={classes.boxAvatar}>
            <div className={classes.avatar}>
              <AvatarComponent
                handleUpdate={this.handleUpdateLogo}
                handleDelete={this.handleDeleteLogo}
                service={service}
              />
            </div>
          </div>
          <div className={classes.text}>
            <div>
              <TypoSession gutterBottom>
                {t("service_ownerspa_spa")}
              </TypoSession>
              <TypoTitle gutterBottom>{service.name}</TypoTitle>
            </div>
            {dropMenu}
          </div>
        </div>
      </>
    );
  }
}

ServiceOwner.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({
  uploadDispatch: dispatch.upload,
  updateServiceForOwner: dispatch.service.updateServiceForOwner,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(ServiceOwner)
  )
);
